export default "__VITE_ASSET__B_678RM9__"